module.exports = __webpack_public_path__ + "img/gift.3d949f10.svg";